import customAxios from "./axiosConfig";

const CompanyOwnerService = {
  list (params) {
    const api_url = window.Urls["company-owner-list"]()
    return customAxios.get(api_url, { params: params })
  },
  create (data) {
    const api_url = window.Urls["company-owner-list"]()
    return customAxios.post(api_url, data)
  },
  destroy (pk) {
    const api_url = window.Urls['company-owner-detail'](pk)
    return customAxios.delete(api_url)
  },
  reactivate (pk) {
    const api_url = window.Urls['company-owner-activate'](pk)
    return customAxios.get(api_url)
  },
};

export default CompanyOwnerService;

// function partial_update(pk, data){
//   var url = Urls['company-owner-detail'](pk);
//   return $http.patch(url, data);
// }